export const ACCOUNT_CONSENT_TOOLTIP =
  'Customer signed to formally consent and be bound by all applicable account agreement(s) and related terms and conditions.';

export const ACCOUNT_MARGIN_TYPE_CASH_TOOLTIP = 'Cash means only settled balances are available to trade.';

export const ACCOUNT_MARGIN_TYPE_LPM_TOOLTIP = 'Limited Purpose Margin (LPM) means unsettled proceeds are available to trade.';
